/** Optional card display label, independent of workflow execution settings. */
export enum StepCardType {
  AGENT = "agent",
  MANUAL = "manual",
}
